import Courses from '@/components/courses';
import Dictionary from '@/components/dictionary';
import Home from '@/components/home';
import Materials from '@/components/materials';
import Vocabularies from '@/components/vocabularies';

export default [
    { id: 'home', title: 'Главная', path: '/', component: Home, icon: 'dashboard' },
    { id: 'courses', title: 'Курсы', path: '/courses', component: Courses, icon: 'library_books' },
    { id: 'materials', title: 'Материалы', path: '/materials', component: Materials, icon: 'book' },
    { id: 'dictionary', title: 'Словарь', path: '/dictionary', component: Dictionary, icon: 'dictionary' },
    { id: 'vocabularies', title: 'Лексика', path: '/vocabularies', component: Vocabularies, icon: 'lists' }
];